import vars from "@/config/vars";
export const getDistanceAndDuration = async (
  start: { latitude: number; longitude: number },
  end: { latitude: number; longitude: number },
) => {
  const coordinate = `${start.longitude},${start.latitude};${end.longitude},${end.latitude}`;

  try {
    const response = await fetch(
      `https://api.mapbox.com/directions/v5/mapbox/walking/${coordinate}?alternatives=true&steps=true&geometries=geojson&access_token=${vars.MapboxKey}`,
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    const distanceInMeters = data.routes[0].distance;
    const distanceInKilometers = distanceInMeters / 1000;
    const duration = data.routes[0].duration;
    const durationInMinutes = Math.round(duration / 60);
    return { distanceInKilometers, durationInMinutes };
  } catch (error) {
    console.error("Error fetching directions:", error);
    return null;
  }
};
